import { Button } from '@Backlot-Cars/archie';
import PropTypes from 'prop-types';
import { AuthCTAWrapper } from './styles';

const AuthFormActions = ({ submitText = 'Submit', onClickSubmit, dataTestId }) => {
	return (
		<AuthCTAWrapper>
			<Button type={onClickSubmit ? 'button' : 'submit'} onClick={onClickSubmit} data-testid={dataTestId}>
				{submitText}
			</Button>
		</AuthCTAWrapper>
	);
};

AuthFormActions.propTypes = {
	submitText: PropTypes.string,
	// when passed it will act as button if not, as a form submit
	onClickSubmit: PropTypes.func,
};

export default AuthFormActions;
